<div class="obg-error-layout-header" *ngIf="showHeader">
	<img obgImageContent="general.brand-logo" onerror="this.style.display = 'none'" />
</div>
<div class="obg-error-layout-content" #content>
	<router-outlet></router-outlet>
</div>
